exports = module.exports = require("../../../../node_modules/fast-css-loader/lib/css-base.js")(false);
// imports

// module
exports.push([module.id, ".school-info {\n  background-color: #fff;\n  border: thin solid #d5d5d5;\n  display: flex;\n  flex-direction: column;\n  margin-bottom: 2rem;\n  padding: 2rem;\n  row-gap: 2rem; }\n  .school-info .control-group {\n    margin-bottom: 0; }\n", ""])